module.exports = __webpack_public_path__ + "img/dummy-user.ffa912aa.jpg";